import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { MenuController, Platform, ToastController } from '@ionic/angular';

import { StatusBar } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

import { Storage } from '@ionic/storage-angular';
import { UserData } from './providers/user-data';

import { environment } from '../environments/environment';
import config from '../../capacitor.config';

import { AppUpdaterService } from './app-updater.service';

export const appEnvironment = environment;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  public appPages = [
    {
      title: 'Power',
      url: '/app/tabs/power',
      icon: 'flash'
    },
    {
      title: 'Live',
      url: '/app/tabs/live',
      icon: 'speedometer'
    },
    {
      title: 'Config',
      url: '/app/tabs/config',
      icon: 'settings'
    },
    {
      title: 'About',
      url: '/app/tabs/about',
      icon: 'information-circle'
    }
  ];
  public loggedIn = false;
  public dark = false;

  constructor(
    private menu: MenuController,
    private platform: Platform,
    private router: Router,
    private storage: Storage,
    private userData: UserData,
    private appUpdater: AppUpdaterService
  ) {
    this.initializeApp();
  }

  async ngOnInit() {
    await this.storage.create();
    this.checkLoginStatus();
    this.listenForLoginEvents();
    this.appUpdater.checkForUpdates();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('hybrid')) {
        StatusBar.hide();
        SplashScreen.hide();
      }

      this.getDarkMode().then((mode) => {
        this.dark = mode;
      })
    });
  }

  getDarkMode(): Promise<boolean> {
    return this.storage.get('darkMode');
  }

  darkModeChanged(newValue) {
    this.storage.set('darkMode', newValue);
  }

  checkLoginStatus() {
    return this.userData.isLoggedIn().then(loggedIn => {
      return this.updateLoggedInStatus(loggedIn);
    });
  }

  updateLoggedInStatus(loggedIn: boolean) {
    setTimeout(() => {
      this.loggedIn = loggedIn;
    }, 300);
  }

  listenForLoginEvents() {
    window.addEventListener('user:login', () => {
      this.updateLoggedInStatus(true);
    });

    window.addEventListener('user:signup', () => {
      this.updateLoggedInStatus(true);
    });

    window.addEventListener('user:logout', () => {
      this.updateLoggedInStatus(false);
    });
  }

  logout() {
    this.userData.logout().then(() => {
      return this.router.navigateByUrl('/app/tabs/power');
    });
  }
}
